if (!customElements.get('upsell-product')) {
  customElements.define(
    'upsell-product',
    class UpsellProduct extends HTMLElement {
      constructor () {
        super();
        this.modalOpener = this.querySelector('modal-opener button');
        this._linkClickHandle = this.linkClickHandle.bind(this);
        this._moveModalTimeout = null;
      }

      linkClickHandle (e) {
        e.preventDefault();

        try {
          this.moveModalToSafeRoot();
        } catch (err) {
          console.warn('[UpsellProduct] moveModalToSafeRoot on click failed:', err);
        }

        if (this.modalOpener) {
          this.modalOpener.dispatchEvent(new Event('click', { bubbles: true }));
        }
      }

      moveModalToSafeRoot () {
        if (!this.modalOpener) {
          this.modalOpener = this.querySelector('modal-opener button');
          if (!this.modalOpener) return;
        }

        const modalId = this.modalOpener.getAttribute('aria-controls');
        if (!modalId) return;

        let root = document.getElementById('upsell-modals-root');
        if (!root) {
          root = document.createElement('div');
          root.id = 'upsell-modals-root';
          root.setAttribute('data-upsell-modals-root', 'true');
          document.body.appendChild(root);
        }

        const escapeId = (id) => {
          if (window.CSS && typeof CSS.escape === 'function') {
            return CSS.escape(id);
          }
          return id.replace(/([ #;?%&,.+*~\':"!^$[\]()=>|/@])/g, '\\$1');
        };

        const selector = '#' + escapeId(modalId);

        const sectionRoot =
          this.closest('[data-section-id]') ||
          this.closest('cart-drawer') ||
          document;

        const modalInSection = sectionRoot.querySelector(selector);
        const modalInRoot = root.querySelector(selector);

        if (!modalInSection) return;

        if (modalInRoot && modalInRoot !== modalInSection) {
          modalInRoot.remove();
        }

        if (modalInSection.parentElement !== root) {
          root.appendChild(modalInSection);
        }

        modalInSection.dataset.upsellModalMoved = 'true';

        try {
          const img = modalInSection.querySelector('img');
          if (img && !img.dataset.upsellPreloaded) {
            img.dataset.upsellPreloaded = '1';
            const src = img.currentSrc || img.src;
            if (src) {
              const preloader = new Image();
              preloader.src = src;
            }
          }
        } catch (e) {
          console.warn('[UpsellProduct] preload image error:', e);
        }
      }

      connectedCallback () {
        this.querySelectorAll('a, img, p').forEach((item) => {
          item.addEventListener('click', this._linkClickHandle);
        });

        this._moveModalTimeout = window.setTimeout(() => {
          try {
            this.moveModalToSafeRoot();
          } catch (e) {
            console.warn('[UpsellProduct] Failed to move modal:', e);
          }
        }, 0);
      }

      disconnectedCallback () {
        this.querySelectorAll('a').forEach((item) => {
          item.removeEventListener('click', this._linkClickHandle);
        });

        if (this._moveModalTimeout !== null) {
          window.clearTimeout(this._moveModalTimeout);
          this._moveModalTimeout = null;
        }
      }
    },
  );

  if (!window.__upsellProductCartRefreshBound) {
    window.__upsellProductCartRefreshBound = true;

    document.addEventListener('cart:refresh', () => {
      document.querySelectorAll('upsell-product').forEach((node) => {
        try {
          if (typeof node.moveModalToSafeRoot === 'function') {
            node.moveModalToSafeRoot();
          }
        } catch (e) {
          console.warn('[UpsellProduct] cart:refresh move error:', e);
        }
      });
    });
  }
}
